import React from "react";
import TalkToOurTeamBTN from "../Coman/TalkToOurTeamBTN";

export default function DefiLendingAndBorrowingHero() {
  return (
    <>
      <section
        className="faq-style-three py_150"
        aria-label="DeFi-Lending-&-Borrowing-Platform-Development-Hero-Section"
        style={{
          backgroundPosition: "50% 50%",
          backgroundSize: "cover",
          backgroundImage:
            "url(assets/img//defi/DeFi-Lending-&-Borrowing-Platform-Development-Hero-Section.jpg)",
        }}
      >
        <div className="auto-container py-4">
          <div className="row clearfix">
            <div className="col-lg-7 col-md-12 col-sm-12 content-column">
              <div className="pt_100">
                <h1 className="text-white">
                  DeFi Lending & Borrowing Platform Development
                </h1>
                <p className="text-white py-3">
                  Unlock the power of decentralized finance with Xeer
                  Technology's cutting-edge DeFi lending and borrowing platform.
                  We provide seamless and secure access to financial services
                  that empower users to lend and borrow digital assets without
                  the need for intermediaries.
                </p>
              </div>

              <div className="btn-box pt-4">
                <TalkToOurTeamBTN />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 image-column"></div>
          </div>
        </div>
      </section>
    </>
  );
}
